import React from 'react';
import { useTranslation } from 'react-i18next';
import FormQuestion from './FormQuestion.js';

const FormSection = ({
  section,
  sIndex,
  formValues,
  vocabularyItems,
  customVocabularyItems,
  departmentsVoc,
  functionalAreaVocs,
  getDescendants,
  answerFiles,
  answerLinks,
  answerObservations,
  answerTexts,
  activeAttachmentTab,
  setActiveAttachmentTab,
  handleInputChange,
  setFormValues,
  setZoomImageUrl,
  getLocalizedText,
  getUrlFromFile,
  isImageFile,
  isQuestionVisible,
  renderAttachmentArea,
  renderFileUploadUI,
  formatScore,
  colors,
  validationErrors = {},
  showScores = false,
  isCollapsed = false,
  onToggle = () => {},
  isSimulation = false
}) => {
  const { t } = useTranslation();

  return (
    <div className="card mb-4">
      {!section.hydeName && (
        <div
          className="card-header d-flex justify-content-between align-items-center"
          style={{ backgroundColor: colors?.secondaryLight || '#e9ecef' }}
        >
          <div>
            <h5 className="mb-0">
              {getLocalizedText(section.name, `${t('section', { ns: 'labels' })} ${sIndex + 1}`)}
            </h5>
            {section.description && (
              <p className="text-muted mb-0 mt-1 small">
                {getLocalizedText(section.description, '')}
              </p>
            )}
          </div>
          <button
            type="button"
            className="btn btn-sm btn-outline-secondary"
            onClick={onToggle}
            aria-expanded={!isCollapsed}
            aria-label={isCollapsed ? t('open', { ns: 'labels', defaultValue: 'Open' }) : t('close', { ns: 'labels', defaultValue: 'Close' })}
            title={isCollapsed ? t('open', { ns: 'labels', defaultValue: 'Open' }) : t('close', { ns: 'labels', defaultValue: 'Close' })}
          >
            <i className={`fa-solid ${isCollapsed ? 'fa-plus' : 'fa-minus'}`}></i>
          </button>
        </div>
      )}
      {!isCollapsed && (
        <div className="card-body">
        {section.questions && section.questions.map((question, qIndex) => {
          // Check visibility conditions
          if (!isQuestionVisible(question)) return null;

          const questionId = question.id || question.questionCode || `question-${sIndex}-${qIndex}`;

          return (
            <FormQuestion
              key={`question-${questionId}`}
              question={question}
              questionId={questionId}
              sIndex={sIndex}
              qIndex={qIndex}
              formValues={formValues}
              vocabularyItems={vocabularyItems}
              customVocabularyItems={customVocabularyItems}
              departmentsVoc={departmentsVoc}
              functionalAreaVocs={functionalAreaVocs}
              getDescendants={getDescendants}
              answerFiles={answerFiles}
              answerLinks={answerLinks}
              answerObservations={answerObservations}
              answerTexts={answerTexts}
              activeAttachmentTab={activeAttachmentTab}
              setActiveAttachmentTab={setActiveAttachmentTab}
              handleInputChange={handleInputChange}
              setFormValues={setFormValues}
              setZoomImageUrl={setZoomImageUrl}
              getLocalizedText={getLocalizedText}
              getUrlFromFile={getUrlFromFile}
              isImageFile={isImageFile}
              renderAttachmentArea={renderAttachmentArea}
              renderFileUploadUI={renderFileUploadUI}
              formatScore={formatScore}
              colors={colors}
              validationErrors={validationErrors}
              showScores={showScores}
              isSimulation={isSimulation}
            />
          );
        })}
        </div>
      )}
    </div>
  );
};

export default FormSection; 